import { Component, Input } from '@angular/core';

@Component({
  selector: 'iboxtools',
  templateUrl: './iboxtools.component.html',
  styles: [
    `
  .ibox-title>h5 {
    display: flex;
    align-items: center;
  }
  `
  ]
})
export class IboxtoolsComponent {
  @Input('title') title: string;
  @Input('color') color: string;

  public collapse(e): void {
    e.preventDefault();
    const ibox = jQuery(e.target).closest('div.ibox');
    ibox.toggleClass('collapsed').toggleClass('border-bottom');
    setTimeout(() => {
      ibox.resize();
      ibox.find('[id^=map-]').resize();
    }, 50);
  }

  public close(e): void {
    e.preventDefault();
    const content = jQuery(e.target).closest('div.ibox');
    content.remove();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/iboxtools/iboxtools.component.ts